'use client';

import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';

import { ApiSchemas } from '@/components/providers/v1-api';

type ApiOffice = ApiSchemas['OfficeReadBase'];

export const ADMIN_OFFICE_COLUMNS: ColumnDef<ApiOffice>[] = [
  {
    header: 'Name',
    accessorKey: 'name',
  },
  {
    header: 'id',
    accessorKey: 'id',
  },
  {
    header: 'Timezone',
    accessorKey: 'timezone',
  },
  {
    header: 'Created At',
    accessorKey: 'created_at',
    cell: ({ row }) => {
      return <span>{format(row.original.created_at, 'MM/dd/yyyy')}</span>;
    },
  },
];
